import { FC, ReactNode } from 'react'
import { SubscriptionTagAvatar, SubscriptionTagAvatarType } from './Avatar'
import { SubscriptionTagOption, SubscriptionTagOptionType } from './Option'
import { SubscriptionTagType, Tag } from './Tag'

const SubscriptionTag: FC &
  SubscriptionTagAvatarType &
  SubscriptionTagOptionType &
  SubscriptionTagType = (): ReactNode => <></>

SubscriptionTag.Avatar = SubscriptionTagAvatar
SubscriptionTag.Option = SubscriptionTagOption
SubscriptionTag.Tag = Tag

export default SubscriptionTag
